import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Database, Users, Globe, Phone, MapPinned, Trees } from 'lucide-react';

const RealEstateHub = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1 style={{ color: '#1e293b', marginBottom: '20px' }}>Real Estate Hub</h1>
      <p style={{ color: '#64748b', marginBottom: '40px' }}>Select a tool to manage your property data.</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        
        {/* Card 1: Master Search Portal (NEW) */}
        <div 
          onClick={() => navigate('/real-estate/master-portal')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#f5f3ff'}}>
            <Globe size={32} color="#7c3aed" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Master Search Portal</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            The "God View". Unified search across Land Sales, Property Sales, and Rental Contracts in one table.
          </p>
        </div>

        {/* Card 2: Lead Gen */}
        <div 
          onClick={() => navigate('/real-estate/lead-gen')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#fef3c7'}}>
            <Users size={32} color="#d97706" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Lead Gen</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Generate and manage leads for your real estate business. Discover potential clients and opportunities.
          </p>
        </div>

        {/* Card 3: Raw Data */}
        <div 
          onClick={() => navigate('/real-estate/raw')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#eff6ff'}}>
            <Database size={32} color="#2563eb" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Raw Data & ZK</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Direct access to government registry tables (ETN) and parsed Land Registry (ZK) PDF extracts.
          </p>
        </div>

        <div 
          onClick={() => navigate('/real-estate/contacts')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#ecfeff'}}>
            <Phone size={32} color="#0f766e" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Contacts</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Browse the unified contact list from lead gen, cold calling, and property showings in one place.
          </p>
        </div>

        <div
          onClick={() => navigate('/real-estate/properties-map')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#fef2f2'}}>
            <MapPinned size={32} color="#dc2626" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Properties Map</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            See all properties currently in selling status on a map with their coordinates.
          </p>
        </div>

        <div
          onClick={() => navigate('/real-estate/land-map')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#f0fdf4'}}>
            <Trees size={32} color="#16a34a" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Land Map</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            View undeveloped building land (nepozidano stavbno zemljišče) on an interactive map.
          </p>
        </div>

      </div>
    </div>
  );
};

// ... Styles (Keep existing styles) ...
const cardStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)', cursor: 'pointer', transition: 'all 0.2s ease', border: '1px solid #e2e8f0', height: '100%', boxSizing: 'border-box' };
const iconBoxStyle = { width: '56px', height: '56px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' };

export default RealEstateHub;